import React, { useEffect, useState } from "react";

// Define prop types using TypeScript
interface RadioInputProps {
  name: string;
  type?: string;
  label: string;
  errors?: any;
  errormessage?: string;
  placeholder?: string;
  defaultValue?: any;
  required?: boolean;
  onChange: (event: { target: { name: string; note: string; status: string; type: string } }) => void;
  value: { status: string | boolean; note: string };
  isDisable?: boolean;
}

const RadioInput: React.FC<RadioInputProps> = ({
  name,
  label,
  onChange,
  value,
  isDisable = false
}) => {
  const [status, setStatus] = useState<string>("false");
  const [note, setNote] = useState<string>("");

  useEffect(() => {
    setStatus(value?.status?.toString() || "false");
    setNote(value?.note?.toString() || "");
  }, [value]);

  const handleRadioChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    inputName: string
  ) => {
    const newValue = event.target.value;
    
    if (inputName === "note") {
      setNote(newValue);
    } else {
      setStatus(newValue);
      if (newValue === "false") {
        setNote("");
      }
    }

    onChange({
      target: {
        name: name,
        note: inputName === "note" ? newValue : note,
        status: inputName === "status" ? newValue : status,
        type: "radio",
      },
    });
  };

  return (
    <div className="radio_yes_no">
      <label>{label}</label>
      <div className="container">
        <div className="radios">
          <label>
            <input
              type="radio"
              value="true"
              checked={status === "true"}
              onChange={(e) => handleRadioChange(e, "status")}
              disabled={isDisable}
            />
            Yes
          </label>
          <label>
            <input
              type="radio"
              value="false"
              checked={status === "false"}
              onChange={(e) => handleRadioChange(e, "status")}
              disabled={isDisable}
            />
            No
          </label>
        </div>

        {status === "true" && (
          <div className="radio__input">
            <input
              type="text"
              name="note"
              value={note}
              onChange={(e) => handleRadioChange(e, "note")}
              disabled={isDisable}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default RadioInput;
